// extracted by mini-css-extract-plugin
module.exports = {"btnSubmit":"style_btnSubmit__WuMUK","btnFacebook":"style_btnFacebook__1G2xF","btnGoogle":"style_btnGoogle__2dVZg","loginFailure":"style_loginFailure__rGy0y"};